import { Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import ManagerBase from "./ManagerBase";
import Attachment from "../models/Attachment";

class AttachmentManager extends ManagerBase {
	constructor () {
		super("attachmentManager");

		this.remoteClassName = "attachment";
	}

	async getTaskAttachmentsForTask (task) {
		const attachmentListResponse = await this.getByGuidList(task.attachmentGuidList);
		const attachmentList = Shark.getInstanceList(Attachment, attachmentListResponse.data);

		// const { currTask } = Shark.get();

		if (task) {
			task.set({
				__attachmentList: attachmentList,
			});
			// Shark.render();

			return true;
		}
		return false;
	}

	async getListByTaskGuid (guid, options) {
		const requestedAction = "get-list-by-task-guid";

		const rd = NousCore.api.createRequest({ item: { guid }, ...options });

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			console.log({data});
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

}

const attachmentManager = new AttachmentManager();

Shark.registerController(attachmentManager);

export default attachmentManager;
